module.exports = __webpack_public_path__ + "img/lzl.549214d5.png";